<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <BannerTabLinks />
                    <BannerUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @update="fetch"
                        @success="onSuccess"
                        @deleted="$router.push(`/banners`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import BannerTabLinks from '@/components/banners/BannerTabLinks';
    import BannerUpsertForm from '@/components/banners/BannerUpsertForm';

    export default {
        name: 'BannerEdit',

        components: {
            BannerTabLinks,
            BannerUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/banners/${id}`)).data;
            },
            onSuccess() {
                const { id } = this.$route.params;
                this.$router.push(`/banners/${id}`)
            }
        },
    };
</script>
